import React, { Component } from 'react'
import Button from '@components/Button'
import DOMPurify from 'dompurify'

class ErrorPage extends Component {
  render() {
    const title = '很抱歉，找不到您的頁面'
    const errorContent =
      "<p className='subtitle is-text-darkgray100'>您可能輸錯網址，或該網頁已刪除、不存在。<br />請點選上方選單，前往您有興趣的頁面或返回首頁繼續瀏覽。</p>"

    return (
      <div className="fourOfour-wrapper">
        <div className="fui-container">
          <div className="fourOfour">
            <div className="fourOfour--left">
              <h2 className="is-text-darkgray50">{this.props.title || title}</h2>
              {this.props.subtitle && (
                <p className="subtitle is-text-darkgray100">{this.props.subtitle}</p>
              )}
              <div
                className="body1 is-text-darkgray100"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(this.props.errorContent || errorContent),
                }}
              ></div>

              <Button btnStyle="primary" link={'/'} className="fui-button is-primary">
                回到首頁
              </Button>
            </div>
            <div className="fourOfour--right">
              <img
                src={
                  'https://www.fetnet.net/content/dam/fetnet/user_resource/cbu/images/system/404_1620x1620.png'
                }
                alt={'404'}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ErrorPage
